module.exports = __webpack_public_path__ + "static/media/alexander-londono-322213.b7655bd4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/alexander-londono-322213.jpg
// module id = 927
// module chunks = 0